import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { appRedirectGuard } from './app-redirect.guard';
import { WalletQrisDetailComponent } from './pages/wallet-qris-detail/wallet-qris-detail.component';
import { WalletQrisInterfaceComponent } from './pages/wallet-qris-interface/wallet-qris-interface.component';
import { WalletQrisTrxPinComponent } from './pages/wallet-qris-trx-pin/wallet-qris-trx-pin.component';
import { WalletQrisTrxStatusComponent } from './pages/wallet-qris-trx-status/wallet-qris-trx-status.component';
import { AccessDeniedComponent } from './shared/access-denied/access-denied.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [appRedirectGuard],
    data: {
      title: 'Qris Transaction',
    },
    component: WalletQrisInterfaceComponent,
    // loadChildren: () =>
    //   import('./pages/wallet-qris-interface/wallet-qris-interface.module').then(
    //     (m) => m.WalletAccountOtpModule
    //   ),
  },
  {
    path: 'qris-detail',
    component: WalletQrisDetailComponent,
  },
  {
    path: 'trx-pin',
    component: WalletQrisTrxPinComponent,
  },
  {
    path: 'trx-status',
    component: WalletQrisTrxStatusComponent,
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  // {
  //   path: 'binding/:id',
  //   component: WalletBindingComponent,
  // },
  {
    path: '**',
    component: AccessDeniedComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
